import Flex from 'antd/es/flex';
import { format } from 'date-fns/format';
import styles from './date-with-dot.module.scss';
import clsx from 'clsx';

interface DateWithDotProps {
  date: Date | string;
  className?: string;
  dotClassName?: string;
}

export default function DateWithDot({ date, className, dotClassName }: DateWithDotProps) {
  return (
    <Flex align="center" className={clsx(className)}>
      <p>{format(date, 'yyyy-MM-dd')}</p>
      <span className={clsx(dotClassName, styles.dot)}></span>
      <p>{format(date, 'h:mm a')}</p>
    </Flex>
  );
}
